import axios from 'axios';
import { decode } from 'jsonwebtoken';
import { Role } from '../../constants/define/role';
import { API_URLS } from '../../constants/urls/api-urls';

export const TOKEN_KEY = 'token';

export type Token = {
  idToken: string;
  refreshToken: string;
  expiresIn: number;
  role: number;
};

export const TokenRepository = {
  getToken: async (): Promise<Token | undefined> => {
    let tokens: Token = { idToken: '', refreshToken: '', expiresIn: 0, role: 3 };
    const localToken = localStorage.getItem(TOKEN_KEY);
    if (localToken && localToken !== 'undefined') {
      tokens = JSON.parse(localToken);
    }

    if (tokens.idToken === '') {
      TokenRepository.remove();
      return undefined;
    }

    if (
      ![Role.ADMIN, Role.SUPER_ADMIN, Role.CUSTOMER_SERVICE, Role.TTB_AGENT, Role.TTB_MANAGER].includes(tokens.role)
    ) {
      TokenRepository.remove();
      return undefined;
    }

    const today = new Date();
    const result = decode(tokens.idToken, { json: true, complete: true });
    if (
      !result ||
      !result?.payload ||
      !result!.payload?.iat ||
      Math.floor((today.getTime() / 1000 - Number(result!.payload?.iat)) / 3600) >= 1
    ) {
      try {
        const headers = {
          Authorization: tokens.idToken,
          clientId: process.env.REACT_APP_LOGIN_ADMIN_PORTAL_CLIENT_ID,
        };
        const tokenData = await axios.post(
          API_URLS.REFRESH_TOKEN,
          {
            refreshToken: tokens.refreshToken,
          },
          { headers },
        );
        if (tokenData.status === 200 && tokenData) {
          const data: Token = {
            idToken: tokenData.data.idToken,
            refreshToken: tokens.refreshToken,
            expiresIn: tokenData.data.expiresIn,
            role: Number(tokenData.data?.role || 3),
          };
          TokenRepository.setToken(data);
          return data;
        }
        TokenRepository.remove();
        return undefined;
      } catch (error) {
        TokenRepository.remove();
        return undefined;
      }
    }
    return tokens;
  },

  setToken: (target: Token): void => {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(target));
  },
  remove: (): void => {
    localStorage.removeItem(TOKEN_KEY);
  },
};
